// extracted by mini-css-extract-plugin
module.exports = {"title-header-popup":"style_title-header-popup__xZUZ4","list-item-popup":"style_list-item-popup__nNkbe"};